import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetNotificationsPaginated = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/notification/rule/all`, {
        data,
      }),
  });

export const useAddNotificationRule = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/notification/rule/add`, {
        data,
        successMessage: "Notification added successfully",
      }),
  });

export const useGetNotificationDetail = () =>
  useMutation({
    mutationFn: (notificationId) =>
      client(`sla/configuration/notification/rule/${notificationId}`),
  });

export const usePutNotificationRule = () =>
  useMutation({
    mutationFn: ({ id, payload }) =>
      client(`sla/configuration/notification/rule/edit/${id}`, {
        method: "put",
        data: payload,
        successMessage: "Successfully Updated Notification",
      }),
  });

export const useExportSlaConf = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/customer/export`, {
        data,
      }),
  });

export const useImportSlaConf = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/customer/import`, {
        method: "post",
        data,
        successMessage: "Customers detail imported successfully",
      }),
  });

export const useDeleteNotification = () =>
  useMutation({
    mutationFn: (id) =>
      client(`sla/configuration/notification/rule/delete/${id}`, {
        method: "delete",
        successMessage: "Notification has been deleted successfully",
      }),
  });
